import { S25Const } from "../s25-const";
import { DurationI } from "../../pojo/DurationI";
import { S25String } from "./s25.string";
import { S25Number } from "./s25.number";
import { isDefined } from "./index";

export namespace S25Duration {
    export function ISODurationToMinutes(extraStr: string): number {
        if (!extraStr) {
            return 0;
        }

        let minutes = 0;
        extraStr = extraStr.trim();
        extraStr = extraStr.toUpperCase();

        const p = extraStr.indexOf("P");
        const d = extraStr.indexOf("D");
        let t = extraStr.indexOf("T");
        const h = extraStr.indexOf("H");
        const m = extraStr.indexOf("M");

        if (d > -1) {
            minutes += parseInt(extraStr.substring(p + 1, d)) * 24 * 60;
        }

        if (t > -1) {
            if (h > -1) {
                minutes += parseInt(extraStr.substring(t + 1, h)) * 60;
                t = h;
            }

            if (m > -1) {
                minutes += parseInt(extraStr.substring(t + 1, m));
            }
        }

        return minutes;
    }

    export function minutesToISODuration(minutes?: number): string {
        return daysHoursMinutesToDuration(daysHoursMinutesObj(minutes));
    }

    export function daysHoursMinutesObj(minutes?: number): DurationI {
        minutes = minutes || 0;
        const ret = { days: 0, hours: 0, minutes: 0 };

        ret.days = Math.floor(minutes / 24 / 60);
        minutes -= ret.days * 24 * 60;

        ret.hours = Math.floor(minutes / 60);
        ret.minutes = minutes - ret.hours * 60;

        return ret;
    }

    export function ISODurationToObj(isoDuration: string) {
        return daysHoursMinutesObj(ISODurationToMinutes(isoDuration));
    }

    export function ISODurationToStr(isoDuration: string) {
        return daysHoursMinutesToStr(ISODurationToObj(isoDuration));
    }

    export function daysHoursMinutesToStr(daysHoursMinutes: DurationI): string {
        return [
            daysHoursMinutes.days ? daysHoursMinutes.days + " Days" : null,
            daysHoursMinutes.hours ? daysHoursMinutes.hours + " Hrs" : null,
            daysHoursMinutes.minutes ? daysHoursMinutes.minutes + " Mins" : null,
        ]
            .filter(isDefined)
            .join(", ");
    }

    export function daysHoursMinutesToDuration(dhm: DurationI): string {
        if (dhm.days + dhm.hours + dhm.minutes === 0) {
            return "P0DT00H00M";
        }
        return (
            "P" +
            (dhm.days ? dhm.days + "D" : "") +
            (dhm.hours + dhm.minutes === 0
                ? ""
                : "T" +
                  (dhm.hours ? S25String.leftPad(dhm.hours, 2) + "H" : "") +
                  (dhm.minutes ? S25String.leftPad(dhm.minutes, 2) + "M" : ""))
        );
    }

    export function getDurationString(minuteDur: number): string {
        const parts = [];
        minuteDur = S25Number.parseInt(minuteDur);

        const days = S25Number.parseInt(minuteDur / (24 * 60));
        days > 0 && parts.push(days + " Day" + (days > 1 ? "s" : ""));
        minuteDur -= days * 24 * 60;

        const hours = S25Number.parseInt(minuteDur / 60);
        hours > 0 && parts.push(hours + " Hour" + (hours > 1 ? "s" : ""));
        minuteDur -= hours * 60;

        minuteDur > 0 && parts.push(minuteDur + " Minute" + (minuteDur > 1 ? "s" : ""));

        return parts.join(", ");
    }

    // Returns duration in milliseconds
    // E.G. -P5Y2M10DT15H36M5S -> -163784165000
    export function parseXmlDuration(expression: string): number {
        if (!expression) return 0;
        const regex = /^(-)?P((\d+)Y)?((\d+)M)?((\d+)D)?(T((\d+)H)?((\d+)M)?((\d+)S)?)?$/g;
        const [_0, neg, _1, year, _2, month, _3, day, _4, _5, hour, _6, min, _7, sec] = regex.exec(expression) ?? [];
        let duration = 0;
        if (year) duration += S25Const.ms.year * parseInt(year);
        if (month) duration += S25Const.ms.month * parseInt(month);
        if (day) duration += S25Const.ms.day * parseInt(day);
        if (hour) duration += S25Const.ms.hour * parseInt(hour);
        if (min) duration += S25Const.ms.min * parseInt(min);
        if (sec) duration += S25Const.ms.sec * parseInt(sec);
        return neg ? -duration : duration;
    }

    //get duration by the start and end numbers, ie: start = 540, end = 620
    export function timesDuration(start: any, end: any) {
        start = timeConvert(parseInt(start));
        end = timeConvert(parseInt(end));
        const startSplit = start.split(":");
        const endSplit = end.split(":");
        return (endSplit[0] - startSplit[0]) * 60 + (endSplit[1] - startSplit[1]);
    }

    //convert an number to hours and mintues. ie: start = 540 = 09:00
    export function timeConvert(num: number) {
        const hours = Math.floor(num / 60);
        const minutes = num % 60;
        return S25String.leftPad(hours, 2) + ":" + S25String.leftPad(minutes, 2);
    }

    export function minutesToTime(mins: string | number): { day: number; hour: number; minute: number } {
        mins = S25Number.toInt(mins);
        let m = mins % 60,
            m60 = Math.floor(mins / 60),
            h = m60 % 24,
            d = Math.floor(m60 / 24);
        h < 0 && (h = 24 + h);
        m < 0 && (m = 60 + m);
        return { day: d, hour: h, minute: m };
    }
}
